import AmexCenturionBanner from './AmexCenturionBanner';

export default AmexCenturionBanner;
